export default __webpack_public_path__ + "static/media/ipm.d5308399.svg";